import { styled } from '../theme';

const SectionHeader = styled('header')(({ theme }) => ({
    flexShrink: 0,
    background: theme.color.white,
    display: 'flex',
    flexFlow: 'row',
    height: 100,
    alignItems: 'center',
    color: theme.color.jetBlack,
}));

export default SectionHeader;
